import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { getLookbookHref } from './homeLookbook';
import { HomeStaticImage } from './HomeStaticImage';
import type { HomeLookbookItem } from './homeLookbook';

type HomeLookbookTileProps = Readonly<{
  item: HomeLookbookItem;
  priority?: boolean;
  className?: string;
  showIndex?: number;
}>;

/**
 * Editorial look tile — tag, caption, product link (restored visual language).
 */
export function HomeLookbookTile({
  item,
  priority = false,
  className = '',
  showIndex,
}: HomeLookbookTileProps) {
  return (
    <Link
      to={getLookbookHref(item)}
      className={`home-lookbook-tile group relative block overflow-hidden rounded-[28px] border border-slate-200/80 bg-slate-100 shadow-sm ${className}`}
    >
      {showIndex !== undefined ? (
        <span
          className="pointer-events-none absolute right-3 top-3 z-[2] text-4xl font-black leading-none text-white/20 select-none"
          aria-hidden
        >
          {String(showIndex).padStart(2, '0')}
        </span>
      ) : null}
      <HomeStaticImage
        src={item.src}
        alt={item.alt}
        fallbackSrc={item.fallbackSrc}
        priority={priority}
        profile="lookbook"
        style={item.objectPosition ? { objectPosition: item.objectPosition } : undefined}
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
      />
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-black/10"
        aria-hidden
      />
      <div className="relative flex h-full min-h-[inherit] flex-col justify-between p-3.5 sm:p-4">
        <span className="inline-flex w-fit rounded-full border border-white/60 bg-white/90 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-slate-800">
          {item.tag}
        </span>
        <div>
          <p className="text-sm font-semibold leading-snug text-white sm:text-base">{item.caption}</p>
          <span className="mt-1.5 inline-flex items-center gap-1 text-[11px] font-semibold text-white/85 lg:opacity-0 lg:transition-opacity lg:group-hover:opacity-100">
            Shop vibe
            <ArrowRightIcon className="h-3 w-3" />
          </span>
        </div>
      </div>
    </Link>
  );
}
